"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
var _security = require("@/utils/security");
var _encryptKey = require("@/config/encryptKey");
var _validate = require("@/utils/validate.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import VDistpicker from 'v-distpicker'
var _default = {
  name: 'arbitratorMaintenance',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      name: '',
      //姓名
      statevalue: '',
      //状态值
      stateArr: [{
        //状态数组
        value: '1',
        label: '已启用'
      }, {
        value: '0',
        label: '已禁用'
      }],
      loading: true,
      total: 0,
      tableData: [],
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      addOrganVisible: false,
      //添加仲裁委显示
      title: '',
      //弹窗标题
      addOrganForm: {
        //添加仲裁委数据
        address: '',
        // addressDetail:'',
        organPhone: '',
        organName: '',
        desc: '',
        status: '启用',
        website: '',
        accessKeyId: '',
        accessKeySecret: '',
        bucketName: '',
        endpoint: '',
        endpointExtranet: ''
      },
      addOrganRules: {
        organName: [{
          required: true,
          message: '请输入机构名称'
        }],
        organPhone: [{
          required: true,
          message: '请输入正确的联系方式（座机号码格式：xxx-xxxxx...）',
          validator: _validate.validPhone
        }],
        address: [{
          required: true,
          message: '请输入地址'
        }],
        status: [{
          required: true,
          message: '请选择状态'
        }],
        website: [{
          required: true,
          message: '请输入官网地址'
        }],
        generalChapter: [{
          required: true,
          message: '   '
        }]
      },
      haveTo: false,
      //通用章提示
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      logoFileList: [],
      action: process.env.VUE_APP_BASE_API + (0, _configure.uploadArbitralBodyFile)(),
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      // 成功上传的图片
      uploadSuccessfile1: '',
      uploadSuccessfile2: '',
      uploadSuccessfile3: '',
      uploadSuccessfile4: '',
      uploadSuccessfile5: '',
      uploadSuccessLogofile: ''
    };
  },
  components: {
    // VDistpicker
  },
  created: function created() {
    this.currentPage = 1;
    this.init();
  },
  methods: {
    // 初始化
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getArbitralBod, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getArbitralBody)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 2:
              _yield$getArbitralBod = _context.sent;
              rows = _yield$getArbitralBod.rows;
              total = _yield$getArbitralBod.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    // 重置初始值
    initStats: function initStats() {
      this.uploadSuccessLogofile = '';
      this.uploadSuccessfile1 = "";
      this.uploadSuccessfile2 = "";
      this.uploadSuccessfile3 = "";
      this.uploadSuccessfile4 = "";
      this.uploadSuccessfile5 = "";
      this.fileList1 = [];
      this.fileList2 = [];
      this.fileList3 = [];
      this.fileList4 = [];
      this.fileList5 = [];
      this.logoFileList = [];
    },
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getArbitralBod2, rows, total, _yield$getArbitralBod3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.initStats();
              if (!(this.name || this.statevalue)) {
                _context2.next = 12;
                break;
              }
              _context2.next = 4;
              return (0, _configure.getArbitralBody)({
                name: this.name,
                state: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 4:
              _yield$getArbitralBod2 = _context2.sent;
              rows = _yield$getArbitralBod2.rows;
              total = _yield$getArbitralBod2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 20;
              break;
            case 12:
              _context2.next = 14;
              return (0, _configure.getArbitralBody)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 14:
              _yield$getArbitralBod3 = _context2.sent;
              _rows = _yield$getArbitralBod3.rows;
              _total = _yield$getArbitralBod3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //添加
    gotoCreate: function gotoCreate() {
      this.addOrganVisible = true;
      this.title = '添加仲裁机构';
      this.initStats();
      if (this.$refs['addOrganForm']) {
        this.$refs['addOrganForm'].resetFields();
      }
    },
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getArbitralBod4, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.total = 1;
              this.currentPage = 1;
              if (!(this.name || this.statevalue)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 5;
              return (0, _configure.getArbitralBody)({
                name: this.name,
                state: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 5:
              _yield$getArbitralBod4 = _context3.sent;
              rows = _yield$getArbitralBod4.rows;
              total = _yield$getArbitralBod4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.statevalue = '';
      this.name = "";
      this.currentPage = 1;
      this.init();
    },
    //表格   编辑
    edit: function edit(val) {
      var _this = this;
      this.initStats();
      this.addOrganVisible = true;
      this.title = '编辑仲裁机构';
      this.currentId = val.id;
      if (this.$refs['addOrganForm']) {
        this.$refs['addOrganForm'].resetFields();
      }
      (0, _configure.checkArbitralBody)(val.id).then(function (res) {
        if (res.code == 1) {
          _this.addOrganForm.organName = res.data.name;
          _this.addOrganForm.organPhone = res.data.phone;
          _this.addOrganForm.desc = res.data.remark;
          _this.addOrganForm.status = res.data.state == 1 ? '启用' : '禁用';
          _this.addOrganForm.website = res.data.website;
          _this.addOrganForm.address = res.data.address;
          _this.addOrganForm.accessKeyId = res.data.accessKeyId;
          _this.addOrganForm.accessKeySecret = res.data.accessKeySecret;
          _this.addOrganForm.bucketName = res.data.bucketName;
          _this.addOrganForm.endpoint = res.data.endpoint;
          _this.addOrganForm.endpointExtranet = res.data.endpointExtranet;
          if (res.data.defaultSign) {
            _this.fileList1.push({
              name: '通用章',
              url: res.data.defaultSign
            });
            _this.uploadSuccessfile1 = res.data.defaultSign;
          }
          if (res.data.registerSign) {
            _this.fileList2.push({
              name: '立案章',
              url: res.data.registerSign
            });
            _this.uploadSuccessfile2 = res.data.registerSign;
          }
          if (res.data.courtSign) {
            _this.fileList4.push({
              name: '开庭章',
              url: res.data.courtSign
            });
            _this.uploadSuccessfile4 = res.data.courtSign;
          }
          if (res.data.ruleSign) {
            _this.fileList5.push({
              name: '裁决章',
              url: res.data.ruleSign
            });
            _this.uploadSuccessfile5 = res.data.ruleSign;
          }
          if (res.data.composeSign) {
            _this.fileList3.push({
              name: '组庭章',
              url: res.data.composeSign
            });
            _this.uploadSuccessfile3 = res.data.composeSign;
          }
          if (res.data.logo) {
            _this.logoFileList.push({
              name: '仲裁委Logo1',
              url: res.data.logo
            });
            _this.uploadSuccessLogofile = res.data.logo;
          }
        }
      });
    },
    // 表格 删除
    deleteRow: function deleteRow(val) {
      var _this2 = this;
      this.$confirm('是否删除该仲裁机构？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteArbitralBody)({
          id: val.id
        }).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.resetTableList();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //修改/添加仲裁机构提交表单
    submitOrganForm: function submitOrganForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid && _this3.uploadSuccessfile1) {
          if (_this3.title == '添加仲裁机构') {
            (0, _configure.addArbitralBody)({
              name: _this3.addOrganForm.organName,
              address: _this3.addOrganForm.address,
              phone: _this3.addOrganForm.organPhone,
              remark: _this3.addOrganForm.desc,
              state: _this3.addOrganForm.status == '启用' ? '1' : '0',
              website: _this3.addOrganForm.website,
              registerSign: _this3.uploadSuccessfile2,
              ruleSign: _this3.uploadSuccessfile5,
              courtSign: _this3.uploadSuccessfile4,
              composeSign: _this3.uploadSuccessfile3,
              defaultSign: _this3.uploadSuccessfile1,
              logo: _this3.uploadSuccessLogofile,
              accessKeyId: _this3.addOrganForm.accessKeyId,
              accessKeySecret: _this3.addOrganForm.accessKeySecret,
              bucketName: _this3.addOrganForm.bucketName,
              endpoint: _this3.addOrganForm.endpoint,
              endpointExtranet: _this3.addOrganForm.endpointExtranet
            }).then(function (res) {
              if (res.code == 1) {
                _this3.addOrganVisible = false;
                _this3.haveTo = false;
                _this3.resetTableList();
                _this3.$refs[formName].resetFields();
              }
            });
          } else {
            (0, _configure.updateArbitralBody)({
              name: _this3.addOrganForm.organName,
              address: _this3.addOrganForm.address,
              phone: _this3.addOrganForm.organPhone,
              remark: _this3.addOrganForm.desc,
              state: _this3.addOrganForm.status == '启用' ? '1' : '0',
              website: _this3.addOrganForm.website,
              registerSign: _this3.uploadSuccessfile2,
              ruleSign: _this3.uploadSuccessfile5,
              courtSign: _this3.uploadSuccessfile4,
              composeSign: _this3.uploadSuccessfile3,
              defaultSign: _this3.uploadSuccessfile1,
              logo: _this3.uploadSuccessLogofile,
              id: _this3.currentId,
              accessKeyId: _this3.addOrganForm.accessKeyId,
              accessKeySecret: _this3.addOrganForm.accessKeySecret,
              bucketName: _this3.addOrganForm.bucketName,
              endpoint: _this3.addOrganForm.endpoint,
              endpointExtranet: _this3.addOrganForm.endpointExtranet
            }).then(function (res) {
              if (res.code == 1) {
                _this3.addOrganVisible = false;
                _this3.haveTo = false;
                _this3.resetTableList();
                _this3.$refs[formName].resetFields();
              }
            });
          }
        } else {
          _this3.haveTo = true;
          return false;
        }
      });
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.resetTableList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.resetTableList();
    },
    // 通用章
    handleRemove1: function handleRemove1(file, fileList) {
      this.fileList1 = [];
      this.uploadSuccessfile1 = '';
      this.haveTo = true;
    },
    handlePreview: function handlePreview(file) {
      if (file.url) {
        window.open(file.url);
      } else {
        var res = JSON.parse((0, _security.decryptByAES)(file.response.response, _encryptKey.encryptKey.key));
        if (res.code == 1) {
          window.open(res.data.href);
        } else {
          location.reload();
        }
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    handleSuccess1: function handleSuccess1(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.uploadSuccessfile1 = res1.data.href;
        this.haveTo = false;
      } else {
        location.reload();
      }
    },
    // 立案章
    handleRemove2: function handleRemove2(file, fileList) {
      this.fileList2 = [];
      this.uploadSuccessfile2 = '';
    },
    handleSuccess2: function handleSuccess2(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.uploadSuccessfile2 = res1.data.href;
      } else {
        location.reload();
      }
    },
    // 组庭章
    handleRemove3: function handleRemove3(file, fileList) {
      this.fileList3 = [];
      this.uploadSuccessfile3 = '';
    },
    handleSuccess3: function handleSuccess3(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.uploadSuccessfile3 = res1.data.href;
      } else {
        location.reload();
      }
    },
    // 开庭章
    handleRemove4: function handleRemove4(file, fileList) {
      this.fileList4 = [];
      this.uploadSuccessfile4 = '';
    },
    handleSuccess4: function handleSuccess4(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.uploadSuccessfile4 = res1.data.href;
      } else {
        location.reload();
      }
    },
    // 裁决章
    handleRemove5: function handleRemove5(file, fileList) {
      this.fileList5 = [];
      this.uploadSuccessfile5 = '';
    },
    handleSuccess5: function handleSuccess5(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.uploadSuccessfile5 = res1.data.href;
      } else {
        location.reload();
      }
    },
    // logo
    handleLogoRemove: function handleLogoRemove(file, fileList) {
      this.logoFileList = [];
      this.uploadSuccessLogofile = '';
    },
    handleLogoSuccess: function handleLogoSuccess(res, file, fileList) {
      var res1 = JSON.parse((0, _security.decryptByAES)(res.response, _encryptKey.encryptKey.key));
      if (res1.code == 1) {
        this.uploadSuccessLogofile = res1.data.href;
      } else {
        location.reload();
      }
    },
    // 上传前判断文件的类型和大小
    beforeUpload: function beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      testmsg = testmsg.toLowerCase();
      var extension = testmsg === 'jpg';
      var isLt2M = file.size / 1024 / 1024 < 5;
      if (!extension) {
        this.$message({
          message: '上传文件只能是jpg格式!',
          type: 'warning'
        });
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }
      return extension && isLt2M;
    },
    // logo上传前判断文件的类型和大小
    beforeLogoUpload: function beforeLogoUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      testmsg = testmsg.toLowerCase();
      var extension = testmsg === 'png';
      var extension1 = testmsg === 'jpg';
      var isLt2M = file.size / 1024 / 1024 < 5;
      if (!extension && !extension1) {
        this.$message({
          message: '上传文件只能是png,jpg格式!',
          type: 'warning'
        });
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }
      return (extension || extension1) && isLt2M;
    }
  }
};
exports.default = _default;